import React from "react";
import styled from "styled-components";
import colors from "../../styles/colors";

type Props = {
    idTagToSkip: string;
};

export default class SkipNav extends React.Component<Props> {
    render(): React.ReactNode {
        return <Link href={`#${this.props.idTagToSkip}`}>Przeskocz do głównej treści</Link>;
    }
};

const Link = styled.a`
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    transition: transform 1s;
    color: ${colors.white};
    background-color: ${colors.red};
    padding: 10px;
    z-index: 999;

    &:focus {
        transform: translateY(0);
        transition: transform 0.1s;
        
        &:hover {
            background-color: ${colors.dark_red};
        }
}
`;